import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container-xxl appointments"
}
const _hoisted_2 = { class: "mt-8 mb-0 text-gray" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fs-sm text-white" }, "Agendar cita", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold mt-8 mb-7" }, "Agenda tu cita", -1)
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header py-5 bg-dark-site" }
const _hoisted_7 = { class: "row align-items-center w-100" }
const _hoisted_8 = { class: "col-lg-1 col-3" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-lg-6 col-9 text-end text-lg-start" }
const _hoisted_11 = { class: "fs-2 fw-bold" }
const _hoisted_12 = { class: "mb-0 text-gray" }
const _hoisted_13 = { class: "col-lg-5 col-9 ms-auto" }
const _hoisted_14 = { class: "fs-1 fw-bold text-end text-success pe-2 mb-0" }
const _hoisted_15 = { class: "card-body rounded-bottom bg-gray-site" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "px-3 px-md-7 col-lg-6 col-xl-4 col-md-6 border-secondary border-end" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "fs-2 fw-bold" }, "Fecha", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Selecciona la fecha de tu cita", -1)
const _hoisted_20 = { class: "px-3 px-md-7 col-xxl-4 col-xl-4 mx-auto col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "fs-2 fw-bold" }, "Horario", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Selecciona tu hora de llegada", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "fs-2 fw-bold" }, "Por la mañana (am)", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "fs-2 fw-bold mt-3" }, "Por la tarde (pm)", -1)
const _hoisted_25 = { class: "px-7 col-md-12 col-lg-6 mx-auto col-xl-4 mt-5 mt-lg-0 text-md-center text-xl-start border-secondary border-start h-100" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "fs-2 fw-bold" }, "Resumen", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "Datos de la cita", -1)
const _hoisted_28 = { class: "fs-2 fw-bold mb-5" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-6" }
const _hoisted_31 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required fw-bold" }, "Nombre")
], -1)
const _hoisted_33 = { class: "position-relative" }
const _hoisted_34 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_35 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-lg-6" }
const _hoisted_39 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Apellidos")
], -1)
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label mb-2 fw-bold" }, "Correo electrónico", -1)
const _hoisted_45 = { class: "position-relative" }
const _hoisted_46 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_47 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "required form-label mb-2 fw-bold" }, "Teléfono", -1)
const _hoisted_52 = { class: "position-relative" }
const _hoisted_53 = { class: "position-absolute translate-middle-y top-50 start-0 ms-3" }
const _hoisted_54 = {
  role: "button",
  class: "svg-icon svg-icon-1hx pointer"
}
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block fs-sm" }
const _hoisted_57 = {
  key: 0,
  class: "col border-1 rounded border-secondary"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Vehículo cargado", -1)
const _hoisted_59 = { class: "mb-1" }
const _hoisted_60 = { class: "text-gray" }
const _hoisted_61 = { class: "col-12" }
const _hoisted_62 = {
  ref: "submitButtonRef",
  type: "submit",
  class: "btn btn-primary btn-lg col-12"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label fs-base" }, " Agendar cita de visita ", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress fs-base" }, [
  /*#__PURE__*/_createTextVNode(" Enviando... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", {
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_add_car",
  class: "btn btn-secondary btn-lg col-12 my-5"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, " Dar mi auto a cuenta")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuccessApointment = _resolveComponent("SuccessApointment")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddVehicle = _resolveComponent("AddVehicle")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.appointment)
      ? (_openBlock(), _createBlock(_component_SuccessApointment, {
          key: 0,
          appointment: $setup.appointment
        }, null, 8, ["appointment"]))
      : (Object.keys($setup.vehicle).length > 0 && !$setup.appointment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                class: "fs-sm text-gray",
                to: "/catalogo"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Comprar vehículos - ")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "fs-sm text-gray",
                to: "/catalogo"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Listado de Vehículo - ")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "fs-sm text-gray",
                to: '/detalle/' + _ctx.$route.params.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.vehicle.brand.brand) + " " + _toDisplayString($setup.vehicle.model.model) + " " + _toDisplayString($setup.vehicle.version.version) + " - ", 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _hoisted_3
            ]),
            _hoisted_4,
            _createVNode(_component_Form, {
              id: "kt_modal_new_card_form",
              class: "form mb-10",
              ref: "formContact",
              novalidate: "novalidate",
              autocomplete: "off",
              onSubmit: $setup.submit,
              "validation-schema": $setup.validationSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: $setup.portada.path,
                          class: "img-fluid",
                          alt: ""
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h2", _hoisted_11, _toDisplayString($setup.vehicle.brand.brand) + " " + _toDisplayString($setup.vehicle.model.model) + " " + _toDisplayString($setup.vehicle.version.version), 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString($setup.vehicle.year.year) + " - " + _toDisplayString($setup.kmFormat($setup.vehicle.mileage)) + " km - " + _toDisplayString($setup.vehicle.model.model) + " - " + _toDisplayString($setup.vehicle.transmission.transmission), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", _hoisted_14, " $" + _toDisplayString($setup.priceFormat($setup.vehicle.price)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _hoisted_19,
                        _createVNode(_component_DatePicker, {
                          masks: { title: 'MMMM YYYY' },
                          "is-expanded": "",
                          "available-dates": $setup.dates,
                          color: "blue",
                          modelValue: $setup.dateCalendar,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateCalendar) = $event)),
                          "is-dark": ""
                        }, null, 8, ["available-dates", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _hoisted_22,
                        _hoisted_23,
                        _createVNode(_component_el_radio_group, {
                          modelValue: $setup.hoursDate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.hoursDate) = $event)),
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.times, (time) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: time.id
                              }, [
                                (parseInt(time.hora.slice(0, 2)) <= 11)
                                  ? (_openBlock(), _createBlock(_component_el_radio_button, {
                                      key: 0,
                                      onClick: ($event: any) => ($setup.saveIdDate(time)),
                                      class: "mx-2 rounded fs-base my-3",
                                      label: time.hora.slice(0, 5)
                                    }, null, 8, ["onClick", "label"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _hoisted_24,
                        _createVNode(_component_el_radio_group, {
                          modelValue: $setup.hoursDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.hoursDate) = $event)),
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.times, (time) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: time.id
                              }, [
                                (parseInt(time.hora.slice(0, 2)) >= 12)
                                  ? (_openBlock(), _createBlock(_component_el_radio_button, {
                                      key: 0,
                                      onClick: ($event: any) => ($setup.saveIdDate(time)),
                                      class: "mx-2 rounded fs-base my-3",
                                      label: time.hora.slice(0, 5)
                                    }, null, 8, ["onClick", "label"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _hoisted_27,
                        _createElementVNode("p", _hoisted_28, _toDisplayString($setup.selectedDate ? $setup.firstCharToUppercase($setup.selectedDate) : "Selecciona una fecha y un horario") + " " + _toDisplayString($setup.hoursDate ? $setup.hoursDate : ""), 1),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("div", _hoisted_33, [
                                _createVNode(_component_Field, {
                                  type: "text",
                                  autocomplete: "off",
                                  class: "form-control border-1 border-secondary ps-10 fs-base",
                                  placeholder: "Luis Daniel",
                                  name: "name",
                                  modelValue: $setup.contactData.name,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.contactData.name) = $event))
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("span", _hoisted_35, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/user.svg" })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(_component_ErrorMessage, { name: "name" })
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _hoisted_40,
                              _createVNode(_component_Field, {
                                type: "text",
                                autocomplete: "off",
                                class: "form-control form-control-solid border-1 border-secondary ps-5 fs-base",
                                placeholder: "Anaya Diaz",
                                name: "last_name",
                                modelValue: $setup.contactData.last_name,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.contactData.last_name) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createVNode(_component_ErrorMessage, { name: "last_name" })
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("div", _hoisted_45, [
                            _createVNode(_component_Field, {
                              type: "text",
                              autocomplete: "off",
                              class: "form-control form-control-solid border-1 border-secondary ps-10 fs-base",
                              placeholder: "example@mail.com",
                              name: "email",
                              modelValue: $setup.contactData.email,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.contactData.email) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("span", _hoisted_47, [
                                _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Correo.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createVNode(_component_ErrorMessage, { name: "email" })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _hoisted_51,
                          _createElementVNode("div", _hoisted_52, [
                            _withDirectives(_createVNode(_component_Field, {
                              type: "text",
                              autocomplete: "off",
                              class: "form-control form-control-solid border-1 border-secondary ps-10 fs-base",
                              placeholder: "333-333-3331",
                              name: "phone",
                              modelValue: $setup.contactData.phone,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.contactData.phone) = $event))
                            }, null, 8, ["modelValue"]), [
                              [_directive_maska, {
                      mask: 'Z##-###-####',
                      tokens: { Z: { pattern: /[1-9]/ } },
                    }]
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("span", _hoisted_54, [
                                _createVNode(_component_inline_svg, { src: "media/icons/iconsax/call.svg" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(_component_ErrorMessage, { name: "phone" })
                            ])
                          ])
                        ]),
                        ($setup.vehicleClient)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                              _hoisted_58,
                              _createElementVNode("p", _hoisted_59, _toDisplayString($setup.vehicleClient.brand.name) + " - " + _toDisplayString($setup.vehicleClient.model.name) + " - " + _toDisplayString($setup.vehicleClient.year.name), 1),
                              _createElementVNode("p", _hoisted_60, _toDisplayString($setup.vehicleClient.version.name) + " - " + _toDisplayString($setup.kmFormat($setup.vehicleClient.km)) + " km ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("button", _hoisted_62, _hoisted_65, 512),
                          _hoisted_66
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_AddVehicle, { onVehicle: $setup.assignVehicle }, null, 8, ["onVehicle"])
  ], 64))
}